<template>
  <div class="content">
    <div class="title">上传打款凭证</div>
    <UploadList v-model="proof" width="150px" height="150px" maxlength="6"></UploadList>
    <el-button type="primary" @click="saveData" :loading="btnLoading" class="btn">上传</el-button>
  </div>
</template>

<script>

import request from '@/utils/request'
import UploadList from '@/components/UploadList/index.vue'

export default {
  components: {
    UploadList
  },
  data() {
    return {
      btnLoading: false,
      id:'',
      proof: [],
      rule: {
        proof: [{ required: true, trigger: 'blur', message: '打款凭证不能为空'}],
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetail()
  },
  methods: {
    getDetail(){
      request({
        url: "/api/backend/shop/cashOut/shopProof",
        method: "get",
        params: {id:this.id}
      }).then(response => {
          this.proof = response.data.proof;
          if(!this.proof) {
            this.proof = []
          }
      });
    },
    saveData() {
      if(this.proof.length == 0) {
        this.$message({
          type: "error",
          message: "请上传打款凭证"
        });
        return
      }
      this.btnLoading = true
      request({
        url: '/api/backend/shopcashout/addProof',
        method: 'post',
        data: {
          id:this.id,
          proof:this.proof,
        }
      }).then(response => {
        this.btnLoading = false
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success',
          duration: 2000
        })
      }).catch((err) => {
        this.btnLoading = false
      })
    },
    cancel() {
      this.$router.go(-1);//返回上一层
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-message-box {
  width: 300px;
}
.title {
  text-align: center;
  margin-bottom: 10px;
}
.content {
  padding: 10px 10px 70px;
}
.btn {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%,0);
}
.success_ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
